<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div class="col-xs-12 mycol">
      <div
        v-if="
          $parent.project.PLAN_BUYERS_PRODUCTS.filter(
            s => s.UF_TYPE_RESIDENT === 1
          ).length
        "
      >
        <strong>Российские компании</strong>
      </div>
      <table
        class="co-executor"
        v-if="
          $parent.project.PLAN_BUYERS_PRODUCTS.filter(
            s => s.UF_TYPE_RESIDENT === 1
          ).length
        "
      >
        <thead>
        <tr>
          <td>ИНН</td>
          <td>Планируемый покупатель</td>
          <td>Вид промышленной продукции</td>
          <td>Наименование товара</td>
          <td>
            Продукция проекта (Требования к промышленной продукции,
            предъявляемые в целях ее отнесения к продукции, произведенной на
            территории Российской Федерации согласно Постановлению №719):
          </td>
          <td>Планируемый срок поставки</td>
          <td>Сумма</td>
          <td></td>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(item, index) in $parent.project.PLAN_BUYERS_PRODUCTS"
          v-if="item.UF_TYPE_RESIDENT === 1"
          v-bind:key="index"
        >
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_INN')
              }"
          >
            <input type="hidden" v-model="item.ID" />
            <input type="hidden" v-model="item.UF_COMPANY_ID" />
<!--            <input
              type="text"
              disabled
              class="i-main-style"
              style="width: 120px;"
              v-model="item.UF_INN"
              v-on:keyup="removeContactError(index, 'UF_INN')"
            />-->
            {{ item.UF_INN }}
            <div class="error-text">
              {{ contactErrorText(index, "UF_INN") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_NAME')
              }"
          >
            <input type="hidden" v-model="item.ID" />
            <input type="hidden" v-model="item.UF_NAME" />
<!--            <input
              type="text"
              class="i-main-style i-co-executor-style"
              v-model="item.UF_NAME"
              disabled
              v-on:keyup="removeContactError(index, 'UF_NAME')"
            />-->
            {{ item.UF_NAME }}
            <div class="error-text">
              {{ contactErrorText(index, "UF_NAME") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_VID_PRODUCTION_ID')
              }"
          >
            <select
              v-model="item.UF_VID_PRODUCTION_ID"
              @change="removeContactError(index, 'UF_VID_PRODUCTION_ID')"
              class="sel-dropdown i-main-style"
              style="min-width:200px; max-width: 250px;"
            >
              <option value=""></option>
              <option
                v-for="itemD in directory.tree_vid_prom_products"
                v-on:change="changeVidProduction(item)"
                v-bind:value="itemD.ID"
                v-bind:key="itemD.ID"
                v-text="itemD.NAME"
                v-show="itemD.ID == 827 || itemD.ID == 843"
              ></option>
            </select>
            <div class="error-text">
              {{ contactErrorText(index, "UF_VID_PRODUCTION_ID") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_N_PRODUCTION_ID')
              }"
          >
            <select
              v-model="item.UF_N_PRODUCTION_ID"
              @change="removeContactError(index, 'UF_N_PRODUCTION_ID')"
              class="sel-dropdown i-main-style"
              style="min-width:200px; max-width: 500px;"
            >
              <option value=""></option>
              <option
                v-for="itemD in vidPodclass(item)"
                v-bind:value="itemD.ID"
                v-bind:key="itemD.ID"
                v-text="itemD.NAME"
              ></option>
            </select>
            <div class="error-text">
              {{ contactErrorText(index, "UF_N_PRODUCTION_ID") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_PRODUCT_REQ_719')
              }"
            style="min-width: 200px; width: 450px;"
          >
              <textarea
                class="i-main-style t-dop-style i-wid-100"
                style="height:114px;"
                v-model="item.UF_PRODUCT_REQ_719"
                placeholder=""
              ></textarea>
            <div class="error-text">
              {{ contactErrorText(index, "UF_PRODUCT_REQ_719") }}
            </div>
          </td>
          <td style="min-width:100px;">
            <select
              v-model="item.UF_KVARTAL"
              class="sel-dropdown i-main-style"
              v-bind:class="{
                  'has-error': hasContactError(index, 'UF_KVARTAL')
                }"
              @change="removeContactError(index, 'UF_KVARTAL')"
              style="padding-right: 10px;"
            >
              <option value=""></option>
              <option
                v-for="item in kvartalList"
                v-bind:value="item"
                v-bind:key="item"
                v-text="item"
              ></option>
            </select
            >&nbsp;квартал

            <select
              v-model="item.UF_YEAR"
              class="sel-dropdown i-main-style"
              @change="removeContactError(index, 'UF_YEAR')"
              v-bind:class="{
                  'has-error': hasContactError(index, 'UF_YEAR')
                }"
              style="padding-right: 10px;"
            >
              <option value=""></option>
              <option
                v-for="item in yearList"
                v-bind:value="item"
                v-bind:key="item"
                v-text="item"
              ></option>
            </select
            >&nbsp;г.

            <div class="error-text">
              {{
                contactErrorText(index, "UF_YEAR") ||
                contactErrorText(index, "UF_KVARTAL")
              }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_SUMM')
              }"
            style="min-width:120px;"
          >
            <input
              type="text"
              class="i-main-style i-co-executor-style"
              :disabled="$parent.$parent.projectDisabled"
              @keyup="removeContactError(index, 'UF_SUMM')"
              v-model="item.UF_SUMM"
              @keypress="isNumber($event)"
            />
            <div class="error-text">
              {{ contactErrorText(index, "UF_SUMM") }}
            </div>
          </td>
          <td>
            <a
              v-show="!$parent.$parent.projectDisabled"
              v-on:click="deleteSubContact(index)"
              class="link-delete-row"
            ></a>
          </td>
        </tr>
        </tbody>
      </table>
      <div
        v-if="
          $parent.project.PLAN_BUYERS_PRODUCTS.filter(
            s => s.UF_TYPE_RESIDENT === 2
          ).length
        "
      >
        <strong>Иностранные компании</strong>
      </div>
      <table
        class="co-executor"
        v-if="
          $parent.project.PLAN_BUYERS_PRODUCTS.filter(
            s => s.UF_TYPE_RESIDENT === 2
          ).length
        "
      >
        <thead>
        <tr>
          <td>Страна</td>
          <td>Идентификационный<br/>код покупателя</td>
          <td>Планируемый покупатель</td>
          <td>Вид продукции</td>
          <td>Наименование товара</td>
          <td>
            Продукция проекта (Требования к промышленной продукции,
            предъявляемые в целях ее отнесения к продукции, произведенной на
            территории Российской Федерации согласно Постановлению №719):
          </td>
          <td>Планируемый срок поставки</td>
          <td>Сумма</td>
          <td></td>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(item, index) in $parent.project.PLAN_BUYERS_PRODUCTS"
          v-if="item.UF_TYPE_RESIDENT === 2"
          v-bind:key="index"
        >
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_COMPANY_ID')
              }"
          >
            <input type="hidden" v-model="item.ID" />
            <input type="hidden" v-model="item.UF_COMPANY_ID" />
<!--            <input
              type="text"
              disabled
              class="i-main-style"
              style="width: 120px;"
              :value="countryName(item)"
              v-on:keyup="removeContactError(index, 'UF_COMPANY_ID')"
            />-->
            {{ countryName(item) }}
            <div class="error-text">
              {{ contactErrorText(index, "UF_COMPANY_ID") }}
            </div>
          </td>
          <td>
            {{ item.UF_CODE }}
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_NAME')
              }"
          >
            <input type="hidden" v-model="item.ID" />
            <input type="hidden" v-model="item.UF_NAME" />
<!--            <input
              type="text"
              class="i-main-style i-co-executor-style"
              disabled
              v-model="item.UF_NAME"
              v-on:keyup="removeContactError(index, 'UF_NAME')"
            />-->
            {{ item.UF_NAME }}
            <div class="error-text">
              {{ contactErrorText(index, "UF_NAME") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_VID_PRODUCTION_ID')
              }"
          >
            <select
              v-model="item.UF_VID_PRODUCTION_ID"
              class="sel-dropdown i-main-style"
              @change="removeContactError(index, 'UF_VID_PRODUCTION_ID')"
              style="min-width:200px; max-width: 250px;"
            >
              <option value=""></option>
              <option
                v-for="itemD in directory.tree_vid_prom_products"
                v-on:change="changeVidProduction(item)"
                v-bind:value="itemD.ID"
                v-bind:key="itemD.ID"
                v-text="itemD.NAME"
                v-show="itemD.ID == 827 || itemD.ID == 843"
              ></option>
            </select>
            <div class="error-text">
              {{ contactErrorText(index, "UF_VID_PRODUCTION_ID") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_N_PRODUCTION_ID')
              }"
          >
            <select
              v-model="item.UF_N_PRODUCTION_ID"
              class="sel-dropdown i-main-style"
              @change="removeContactError(index, 'UF_N_PRODUCTION_ID')"
              style="min-width: 200px;max-width: 500px;"
            >
              <option value=""></option>
              <option
                v-for="itemD in vidPodclass(item)"
                v-bind:value="itemD.ID"
                v-bind:key="itemD.ID"
                v-text="itemD.NAME"
              ></option>
            </select>
            <div class="error-text">
              {{ contactErrorText(index, "UF_N_PRODUCTION_ID") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_PRODUCT_REQ_719')
              }"
            style="min-width: 200px;width: 450px;"
          >
              <textarea
                class="i-main-style t-dop-style i-wid-100"
                style="height:114px;"
                v-model="item.UF_PRODUCT_REQ_719"
                placeholder=""
              ></textarea>
            <div class="error-text">
              {{ contactErrorText(index, "UF_PRODUCT_REQ_719") }}
            </div>
          </td>
          <td style="min-width:100px;">
            <select
              v-model="item.UF_KVARTAL"
              class="sel-dropdown i-main-style"
              v-bind:class="{
                  'has-error': hasContactError(index, 'UF_KVARTAL')
                }"
              @change="removeContactError(index, 'UF_KVARTAL')"
              style="padding-right: 10px;"
            >
              <option value=""></option>
              <option
                v-for="item in kvartalList"
                v-bind:value="item"
                v-bind:key="item"
                v-text="item"
              ></option>
            </select
            >&nbsp;квартал

            <select
              v-model="item.UF_YEAR"
              class="sel-dropdown i-main-style"
              @change="removeContactError(index, 'UF_YEAR')"
              v-bind:class="{
                  'has-error': hasContactError(index, 'UF_YEAR')
                }"
              style="padding-right: 10px;"
            >
              <option value=""></option>
              <option
                v-for="item in yearList"
                v-bind:value="item"
                v-bind:key="item"
                v-text="item"
              ></option>
            </select
            >&nbsp;г.

            <div class="error-text">
              {{
                contactErrorText(index, "UF_YEAR") ||
                contactErrorText(index, "UF_KVARTAL")
              }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_SUMM')
              }"
            style="min-width:120px;"
          >
            <input
              type="text"
              class="i-main-style i-co-executor-style"
              :disabled="$parent.$parent.projectDisabled"
              @keyup="removeContactError(index, 'UF_SUMM')"
              v-model="item.UF_SUMM"
              @keypress="isNumber($event)"
            />
            <div class="error-text">
              {{ contactErrorText(index, "UF_SUMM") }}
            </div>
          </td>
          <td>
            <a
              v-show="!$parent.$parent.projectDisabled"
              v-on:click="deleteSubContact(index)"
              class="link-delete-row"
            ></a>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="add-row" v-show="!$parent.$parent.projectDisabled">
        <a @click="showConfirm = true" class="link-add-row"
        >Добавить покупателя продукции</a
        >
      </div>
    </div>
    <div
      class="modal fade in"
      v-bind:class="{ show: showConfirm }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showConfirm = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Добавление покупателя продукции</h4>
          </div>
          <div class="modal-body">
            <p>
              Добавление планируемого покупателя продукции - Российская или
              иностранная компания.
            </p>
            <p>
              Продолжить?
            </p>
          </div>
          <div class="modal-footer">
            <button
              @click="showResidentWindow"
              type="button"
              class="btn btn-primary"
            >
              Да
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              v-on:click="showConfirm = false"
            >
              Нет
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div
      class="modal fade in"
      v-bind:class="{ show: showResident }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showResident = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Укажите тип покупателя</h4>
          </div>
          <div class="modal-body">
            <select v-model="resident" class="form-control">
              <option :value="1">Российская компания</option>
              <option :value="2">Иностранная компания</option>
            </select>
          </div>
          <div class="modal-footer">
            <button @click="setResident" type="button" class="btn btn-primary">
              Далее
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              v-on:click="showResident = false"
            >
              Отмена
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div
      class="modal fade in"
      v-bind:class="{ show: showCompIn }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showCompIn = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Добавление иностранной организации</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Название организации</label>
              <input v-model="inname" class="form-control" />
            </div>
            <div class="form-group">
              <label>Страна</label>
              <select v-model="incountry" class="form-control">
                <option
                  v-for="item in directory.country"
                  :value="item.ID"
                  :key="item.ID"
                  v-text="item.NAME"
                ></option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="addInSubContact"
              :disabled="inname === '' || incountry === 0"
              type="button"
              class="btn btn-primary"
            >
              Добавить организацию
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="showCompIn = false"
            >
              Отмена
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div
      class="modal fade in"
      v-bind:class="{ show: showOgrnFind }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showOgrnFind = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Добавление российской организации</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>ОГРН</label>
              <input
                v-model="ogrn"
                class="form-control"
                placeholder="ОГРН организации"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="addSubContact"
              type="button"
              class="btn btn-primary"
            >
              Добавить организацию
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <!-- Поиск организации без разделения -->
    <div
      class="modal fade in"
      v-bind:class="{ show: showAllSearchOrg }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showAllSearchOrg = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Добавление покупателя продукции</h4>
          </div>
          <div class="modal-body">

            <p class="select-blue-desc">
              Начните вводить Название или ИНН/Регистрационный номер контрагента,
              затем выберите нужный из списка.
              Если ничего не найдено, добавьте нового контрагента, нажав на '+'
            </p>
            <div class="form-group">
              <div class="form-group add-row autocomplete-form-add">
                <table>
                  <tbody>
                  <tr>
                    <td>
                      <v-autocomplete
                        :items="orgsList"
                        input-class="form-control"
                        :auto-select-one-item="false"
                        :keep-open="false"
                        :component-item="act"
                        v-model="selectedOrg"
                        ref="autoSearchInputRef"
                        :min-len="3"
                        :get-label="getLabel"
                        placeholder="Название или ИНН/Идентификационный код контрагента"
                        @update-items="searchAllOrg"
                        @change="isSearchGood = true"
                        @input="selectSearchItems"
                      ></v-autocomplete>
                    </td>
                    <td class="button-del" v-if="selectedOrg">
                      <a @click="clearAutocomplete" class="link-delete-row"></a>
                    </td>
                    <td class="button-del" v-else-if="!isSearchGood">
                      <a @click="resetAutocomplete" class="link-delete-row"></a>
                    </td>
                    <td class="button-add">
                      <a
                        class="link-add-row"
                        style="width: 20px; padding: 0;"
                        :href='getLinkOlk()'
                        title="Добавить контрагента"
                        target="_blank"></a>
                    </td>
                  </tr>
                  <tr v-if="!isSearchGood">
                    <td colspan="2">
                      <p style="text-align: left; font-style: italic;">По вашему запросу ничего не найдено, попробуйте
                        изменить запрос</p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button
              @click="addAllTypeSubContact"
              :disabled="!isAddAllOrgGood"
              type="button"
              class="btn btn-primary"
            >
              Добавить организацию
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="showAllSearchOrg = false"
            >
              Отмена
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>


  </div>
</template>

<script>
import Vue from "vue";
import { ProjectsService } from "@/common/api.service";
import { mapGetters } from "vuex";
import { FETCH_DIRECTORY } from "@/store/actions.type";
import Item from "@/components/expert/Item.vue";

export default {
  name: "plan_buyers_products",
  data() {
    return {
      showConfirm: false,
      showOgrnFind: false,
      showResident: false,
      showCompIn: false,
      showAllSearchOrg: false,
      resident: 1,
      inname: "",
      incountry: 0,
      ogrn: "",
      yearList: [],
      kvartalList: [1, 2, 3, 4],
      variantAddOrg: 2,
      nameOrg: "",
      query: "",
      selectedOrg: "",
      orgsList: [],
      act: Item,
      isViewNameOrg: false,
      isSearchGood: true,
      isAddAllOrgGood: false
    };
  },
  methods: {
    hasContactError(col, field) {
      if (
        typeof this.$parent.$parent.planBuyersProductsErrors[col] !==
        "undefined"
      ) {
        if (
          typeof this.$parent.$parent.planBuyersProductsErrors[col][field] !==
          "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    contactErrorText(col, field) {
      if (
        typeof this.$parent.$parent.planBuyersProductsErrors[col] !==
        "undefined"
      ) {
        if (
          typeof this.$parent.$parent.planBuyersProductsErrors[col][field] !==
          "undefined"
        ) {
          return this.$parent.$parent.planBuyersProductsErrors[col][field];
        }
      }
      return "";
    },
    removeContactError(col, field) {
      if (
        typeof this.$parent.$parent.planBuyersProductsErrors[col] !==
        "undefined"
      ) {
        if (
          typeof this.$parent.$parent.planBuyersProductsErrors[col][field] !==
          "undefined"
        ) {
          Vue.delete(this.$parent.$parent.planBuyersProductsErrors[col], field);
        }
      }
      return false;
    },
    countryName(item) {
      const result = this.directory.country.filter(
        c => c.ID === item.UF_COUNTRY_ID
      );
      return result.length > 0 ? result[0].NAME : "";
    },
    findСountryByCode(item) {
      if (item && item.counterparty && item.counterparty.countryCode) {
        const result = this.directory.country.filter(
          c => c.CODE === item.counterparty.countryCode
        );
        return result[0];
      }
    },
    addSubContact() {
      ProjectsService.getCoAuthorInfoByOgrn(this.ogrn).then(({ data }) => {
        if (!data.IS_FIND) {
          this.$toasted.show(data.ERROR, {
            theme: "red",
            position: "top-right",
            duration: 3000
          });
          return;
        }
        this.showOgrnFind = false;
        if (typeof this.$parent.project.PLAN_BUYERS_PRODUCTS === "undefined") {
          this.$parent.project.PLAN_BUYERS_PRODUCTS = [];
        }
        this.$parent.project.PLAN_BUYERS_PRODUCTS.push({
          UF_PROJECT_ID: this.$parent.project.ID,
          UF_TYPE_RESIDENT: this.resident,
          UF_OGRN: data.UF_OGRN,
          UF_NAME: data.UF_NAME,
          UF_COMPANY_ID: data.UF_COMPANY_ID,
          UF_VID_PRODUCTION_ID: "",
          UF_N_PRODUCTION_ID: "",
          UF_PRODUCT_REQ_719: "",
          UF_YEAR: "",
          UF_KVARTAL: "",
          UF_SUMM: ""
        });
      }, this);
    },
    addInSubContact() {
      this.showCompIn = false;
      if (typeof this.$parent.project.PLAN_BUYERS_PRODUCTS === "undefined") {
        this.$parent.project.PLAN_BUYERS_PRODUCTS = [];
      }
      this.$parent.project.PLAN_BUYERS_PRODUCTS.push({
        UF_PROJECT_ID: this.$parent.project.ID,
        UF_TYPE_RESIDENT: this.resident,
        UF_NAME: this.inname,
        UF_COUNTRY_ID: this.incountry,
        UF_VID_PRODUCTION_ID: "",
        UF_PRODUCT_REQ_719: "",
        UF_N_PRODUCTION_ID: "",
        UF_YEAR: "",
        UF_KVARTAL: ""
      });
    },
    deleteSubContact(index) {
      this.$parent.project.PLAN_BUYERS_PRODUCTS.splice(index, 1);
      if (this.$parent.project.PLAN_BUYERS_PRODUCTS.length === 0) {
        //this.project.SUBCONTRACTORS.push({});
      }
    },
    showResidentWindow() {
      this.showConfirm = false;
      this.ogrn = "";
      if (this.variantAddOrg == 1) {
        this.showResident = true;
      } else {
        this.showAllSearchOrg = true;
      }
    },
    addAllTypeSubContact() {
      if (this.isAddAllOrgGood) {
        this.resident = (this.selectedOrg.counterparty.type === "ForeignOrganization") ? 2 : 1;

        if (typeof this.$parent.project.PLAN_BUYERS_PRODUCTS === "undefined") {
          this.$parent.project.PLAN_BUYERS_PRODUCTS = [];
        }

        if (this.resident === 2) {

          let countryId = 0;
          let country = this.findСountryByCode(this.selectedOrg);
          if (country.ID > 0) {
            countryId = country.ID;
          }

          this.$parent.project.PLAN_BUYERS_PRODUCTS.push({
            UF_PROJECT_ID: this.$parent.project.ID,
            UF_TYPE_RESIDENT: this.resident,
            UF_NAME: this.selectedOrg.counterparty.shortName,
            UF_CODE: this.selectedOrg.counterparty.registrationNumber,
            UF_COUNTRY_ID: countryId,
            UF_VID_PRODUCTION_ID: "",
            UF_PRODUCT_REQ_719: "",
            UF_N_PRODUCTION_ID: "",
            UF_YEAR: "",
            UF_KVARTAL: "",
            DATA_OLK: this.selectedOrg
          });
        } else {
          this.$parent.project.PLAN_BUYERS_PRODUCTS.push({
            UF_PROJECT_ID: this.$parent.project.ID,
            UF_TYPE_RESIDENT: this.resident,
            UF_OGRN: (this.selectedOrg.counterparty.ogrnIp)?this.selectedOrg.counterparty.ogrnIp:this.selectedOrg.counterparty.ogrn,
            UF_INN: this.selectedOrg.counterparty.inn,
            UF_NAME: (this.selectedOrg.counterparty.ogrnIp)?this.selectedOrg.counterparty.fullName:this.selectedOrg.counterparty.shortName,
            UF_COMPANY_ID: 0,
            UF_VID_PRODUCTION_ID: "",
            UF_N_PRODUCTION_ID: "",
            UF_PRODUCT_REQ_719: "",
            UF_YEAR: "",
            UF_KVARTAL: "",
            UF_SUMM: "",
            DATA_OLK: this.selectedOrg
          });
        }

        this.showAllSearchOrg = false;
        this.clearAutocomplete();
        this.resetAutocomplete();
      }
    },
    setResident() {
      if (this.resident === 1) {
        this.findOrg();
      }
      if (this.resident === 2) {
        this.showIn();
      }
    },
    showIn() {
      this.showResident = false;
      this.inname = "";
      this.incountry = 0;
      this.showCompIn = true;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    findOrg() {
      this.showResident = false;
      this.ogrn = "";
      this.showOgrnFind = true;
    },
    changeVidProduction(item) {
      item.UF_N_PRODUCTION_ID = "";
    },
    vidPodclass(item) {
      if (item.UF_VID_PRODUCTION_ID < 1) {
        return [];
      }
      let t = this.directory.tree_vid_prom_products.filter(
        c => c.ID === item.UF_VID_PRODUCTION_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }

      return [];
    },
    searchAllOrg(query) {
      this.isSearchGood = true;
      if (query !== undefined) {
        ProjectsService.getFindOrgByGetWay({ search: query }).then(({ data }) => {
          this.orgsList = data.items;
          this.isSearchGood = (this.orgsList.length > 0) ? true : false;
        });
      }
    },
    clearAutocomplete() {
      this.selectedOrg = null;
      this.orgsList = [];
      this.isAddAllOrgGood = false;
    },
    resetAutocomplete() {
      this.$refs.autoSearchInputRef.searchText = "";
      this.selectedOrg = null;
      this.isAddAllOrgGood = false;
      this.isSearchGood = true;
    },
    selectSearchItems() {
      if (this.selectedOrg && this.selectedOrg.id !== "") {
        this.isAddAllOrgGood = true;
      }
    },
    getLabel(item) {
      if (item) {
        return item.UF_NUMBER + " " + item.UF_NAME;
      }
    },
    getLinkOlk() {
      return (this.$parent.project.META.OLK_COUNTERPARTY_PAGE) ? this.$parent.project.META.OLK_COUNTERPARTY_PAGE : "https://olk.frprf.ru/counterparty/";
    }
  },
  mounted() {
    this.$store.dispatch(FETCH_DIRECTORY, ["country"]);
    this.$store.dispatch(FETCH_DIRECTORY, ["tree/vid_prom_products"]);

    for (
      let i = this.$parent.project.YEAR_SETTING.dateNow;
      i < this.$parent.project.YEAR_SETTING.dateNow + 10;
      i++
    ) {
      this.yearList.push(i);
    }
  },
  computed: {
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
